define("StockInformation.Model", 
    [
        "Backbone", 
        "Utils"
    ], 
function(
    Backbone,
    Utils
) {
    "use strict";

    return Backbone.Model.extend({
        
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "services/StockInformation.Service.ss"
            )
        )
        
    });
});
